/**
 * Report form tab (scoring).
 */
import * as React from 'react';
import { Star } from 'lucide-react';
import { SCORING_TARGET_LABELS } from '@/components/reports/report-configs';
import { ScoringContent } from '@/components/reports/remote/renderReportDetails';
import { DetailsCard } from '@/components/common/DetailsCard';
import { EmptyPlaceholder } from '@/components/common/details/EmptyPlaceholder';
import type { ReportScoringEntry } from '@/types/remote/report.types';
import { hasScoringEntries } from '@/components/reports/remote/report-form-utils';

/** Props for {@link ScoringTab}. */
export interface ScoringTabProps {
  schemaId: string;
  entries: ReportScoringEntry[] | undefined;
}

/** Remote scoring entries tab. */
export const ScoringTab: React.FC<Readonly<ScoringTabProps>> = ({ schemaId, entries }) => {
  if (!hasScoringEntries(entries) || !entries) {
    return (
      <DetailsCard icon={Star} title="Scoring" colorName="color-3" colSpan="full">
        <EmptyPlaceholder message="Scoring non encore renseigné" />
      </DetailsCard>
    );
  }

  return (
    <div className="space-y-4">
      {entries.map((entry) => {
        let title = 'Scoring';
        if (schemaId === 'scoring_eleve') {
          title =
            entry.targetRole === 'student'
              ? 'Scoring élève'
              : `Scoring élève — ${SCORING_TARGET_LABELS[entry.targetRole] ?? entry.targetRole}`;
        } else if (schemaId === 'scoring_light_ri' || schemaId === 'scoring_light_ra') {
          title = 'Scoring light';
        }
        return (
          <DetailsCard key={entry.id} icon={Star} title={title} colorName="color-3" colSpan={1}>
            <ScoringContent schemaId={schemaId} fields={entry.fields} />
          </DetailsCard>
        );
      })}
    </div>
  );
};
